"use client";
//import { FirebaseApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  addDoc,
  collection,
  getFirestore,
  onSnapshot,
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import {app} from "../base"

export const getCheckoutUrl = async (prices,fee) => {
  let prefix = "https://"
  if(window.location.hostname==="localhost"){
    prefix = "http://"
  }
  const YOUR_DOMAIN = prefix+window.location.host+"/success"

  const currency="aud"
  const auth = getAuth(app);
  const userId = auth.currentUser?.uid;
  if (!userId) throw new Error("User is not authenticated");

  const db = getFirestore(app);
  const checkoutSessionRef = collection(
    db,
    "users",
    userId,
    "checkout_sessions"
  );
  // Fee line temporarily removed — a one-time price_data line alongside the
  // recurring price in subscription mode was complicating checkout. The `fee`
  // arg is accepted for signature compatibility but no longer added.
  void fee;
  // Seat count is derived server-side from the purchased price (see
  // PRICE_TO_TIER in functions/index.js), so no quantity is passed back here.
  const docRef = await addDoc(checkoutSessionRef, {
    line_items:prices,
    success_url: `${YOUR_DOMAIN}?user_id=${userId}`,
    cancel_url: window.location.origin,
    mode : 'subscription',
    payment_method_types : ['card'],
    // Let customers enter a Stripe promotion code at checkout. Codes only apply
    // if created in Stripe (e.g. a 100%-off code for $0 end-to-end testing, or
    // real discounts), so this is safe to leave on permanently.
    allow_promotion_codes : true,
    currency:currency
  });

  return new Promise((resolve, reject) => {
    const unsubscribe = onSnapshot(docRef, (snap) => {
      const { error, url } = snap.data()
      if (error) {
        unsubscribe();
        reject(new Error(`An error occurred: ${error.message}`));
      }
      if (url) {
        unsubscribe();
        resolve(url);
      }
    });
  });
};

export const getPortalUrl = async (app) => {
  const auth = getAuth(app);
  const user = auth.currentUser;

  let dataWithUrl
  try {
    const functions = getFunctions(app, "us-central1");
    const functionRef = httpsCallable(
      functions,
      "ext-firestore-stripe-payments-createPortalLink"
    );
    const { data } = await functionRef({
      customerId: user?.uid,
      returnUrl: window.location.origin,
    });

    dataWithUrl = data;
  } catch (error) {
    console.error(error);
  }

  return new Promise((resolve, reject) => {
    if (dataWithUrl.url) {
      resolve(dataWithUrl.url);
    } else {
      reject(new Error("No url returned"));
    }
  });
};



// Tiered subscriptions. Each tier is a recurring yearly Stripe price. `seats`
// is how many license codes the webhook mints per purchase. Prices are AUD/yr.
// NOTE: these price IDs + seat counts are mirrored server-side in
// PRICE_TO_TIER (functions/index.js). Keep the two in sync — the client picks
// the price here, the webhook maps it back to tier/seats there.
const testSubscriptionIds = {
  parents: { id: "price_1TedtWEIYZealXg6yCEXJt2K", price: 300, seats: 1 },
  regular: { id: "price_1TeduVEIYZealXg6DcD5DXO5", price: 990, seats: 3 },
  premium: { id: "price_1TedvOEIYZealXg6wUIJYAuS", price: 2500, seats: 3 },
};

const liveSubscriptionIds = {
  parents: { id: "price_1TeeP7EIYZealXg6dpOGIxIk", price: 300, seats: 1 },
  regular: { id: "price_1TeeP5EIYZealXg6JSUUpzmC", price: 990, seats: 3 },
  premium: { id: "price_1TeeP3EIYZealXg6QPmYNEI9", price: 2500, seats: 3 },
};

// Pick test vs live prices by the FIREBASE PROJECT this build targets, NOT the
// hostname. The Stripe mode is configured per project server-side (the prod
// project uses sk_live, staging/local use sk_test), so the price IDs must match
// the project, or checkout sends live price IDs into a test-mode backend (and
// vice versa). Only the real production project gets live prices; staging and
// localhost (which point at piggybackjoy-staging) get test prices.
const PROD_PROJECT_ID = "piggybackjoy";
export const subscriptionIds =
  app.options?.projectId === PROD_PROJECT_ID
    ? liveSubscriptionIds
    : testSubscriptionIds;
